import React, { useEffect } from 'react';
import { toast } from 'sonner';
import { IMAGES } from '../utils/constants';
const buyers = [{
  name: 'Marco',
  city: 'Roma'
}, {
  name: 'Giulia',
  city: 'Milano'
}, {
  name: 'Luca',
  city: 'Napoli'
}, {
  name: 'Francesca',
  city: 'Torino'
}, {
  name: 'Matteo',
  city: 'Firenze'
}, {
  name: 'Alessandro',
  city: 'Bologna'
}, {
  name: 'Chiara',
  city: 'Palermo'
}, {
  name: 'Davide',
  city: 'Genova'
}, {
  name: 'Sofia',
  city: 'Bari'
}, {
  name: 'Andrea',
  city: 'Catania'
}, {
  name: 'Elena',
  city: 'Verona'
}, {
  name: 'Giuseppe',
  city: 'Padova'
}];
export function PurchasePopup() {
  useEffect(() => {
    const interval = setInterval(() => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      toast.custom(t => <div className="bg-white p-3 rounded-xl shadow-xl border border-gray-100 flex items-center gap-4 max-w-sm animate-in slide-in-from-bottom-5" data-id="element-250">
            <div className="w-12 h-16 flex-shrink-0 rounded overflow-hidden shadow-sm" data-id="element-251">
              <img src={IMAGES.tomo1} alt="Mega-Pack" className="w-full h-full object-cover" data-id="element-252" />
            </div>
            <div data-id="element-253">
              <p className="text-sm font-semibold text-gray-900" data-id="element-254">
                {randomBuyer.name} da {randomBuyer.city}
              </p>
              <p className="text-xs text-gray-600 mt-0.5" data-id="element-255">
                ha appena acquistato il Mega-Pack!
              </p>
              <p className="text-[10px] text-green-600 font-bold mt-1 uppercase tracking-wider" data-id="element-256">
                ✓ Acquisto Verificato
              </p>
            </div>
          </div>, {
        duration: 4000,
        position: 'bottom-left'
      });
    }, 15000); // Every 15 seconds
    return () => clearInterval(interval);
  }, []);
  return null;
}